import { useQuery } from '@tanstack/react-query';
import { AorQueries, AorServiceQueryKeys } from './query';
import { GeoJson } from './types';

export const useGetDistrictLocationFromGeometry = (geometry: GeoJson) => {
  const response = useQuery({
    queryKey: [AorServiceQueryKeys.GET_DISTRICTS_FROM_GEOMETRY, geometry?.type, geometry?.coordinates],
    queryFn: () => AorQueries.getDistrictLocationFromGeometry(geometry),
    enabled: !!geometry?.type && !!geometry?.coordinates,
  });

  return response.data;
};
